<template>
  <div>
    <NavBar />
    <div class="container">
      <SideBar />
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <h1 class="title">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 495.212 495.212"
              style="enable-background: new 0 0 495.212 495.212"
              xml:space="preserve"
            >
              <g id="XMLID_415_">
                <path
                  id="XMLID_417_"
                  d="M171.492,96.586c26.688,0,48.314-21.616,48.314-48.288c0-26.679-21.626-48.295-48.314-48.295 c-26.67,0-48.276,21.616-48.276,48.295C123.216,74.97,144.823,96.586,171.492,96.586z"
                />
                <path
                  id="XMLID_416_"
                  d="M445.941,48.5L348.798,1.592c-3.811-1.847-8.229-2.096-12.23-0.7c-4.032,1.402-7.328,4.339-9.168,8.164 l-28.026,58.04c-3.86,7.972-0.503,17.558,7.468,21.405l37.408,18.063l-27.884,57.696l-52.64,23.88l-31.689-69.458 c-3.583-7.873-11.506-12.343-19.656-12.006h-81.776c-8.15-0.337-16.054,4.133-19.656,12.006L42.084,269.566 c-4.731,10.374-0.16,22.632,10.229,27.366c10.457,4.762,22.638,0.122,27.369-10.214l33.267-72.909 c0,8.681-0.061,92.467-0.061,256.621c0,13.691,11.101,24.783,24.786,24.783c13.697,0,24.786-11.092,24.786-24.783V322.727h18.072 V470.43c0,13.691,11.101,24.783,24.786,24.783c13.697,0,24.786-11.092,24.786-24.783c0-133.18-0.068-216.322-0.068-256.621 l4.682,10.23c3.468,7.591,10.972,12.086,18.816,12.086c2.834,0,5.744-0.598,8.517-1.856l26.271-11.924l-0.099,0.224 c-2.988,6.164-0.405,13.571,5.763,16.548c1.725,0.84,3.566,1.236,5.37,1.236c4.615,0,9.04-2.575,11.168-7.005l13.04-26.985 l13.845-6.288c10.39-4.709,14.986-16.949,10.278-27.341c-1.165-2.549-2.792-4.737-4.73-6.544l23.589-48.845l37.421,18.066 c3.823,1.847,8.229,2.099,12.249,0.703c4.02-1.405,7.309-4.342,9.168-8.164l28.008-58.044 C457.25,61.933,453.906,52.348,445.941,48.5z"
                />
              </g>
            </svg>
            Propagandas
          </h1>
          <ul class="tabs">
            <li>
              <router-link to="/propaganda">Dados</router-link>
            </li>
            <li class="tab-active">
              <router-link to="/propaganda/bg">Background</router-link>
            </li>
          </ul>
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-1">
                  <h3 class="subtitle">
                    Imagens em
                    <strong class="label success">1290 x 960</strong>
                  </h3>
                  <label class="button button-success button-lg">
                    <svg
                      style="
                        float: left;
                        margin-right: 12px;
                        width: 18px;
                        height: 18px;
                        fill: #fff;
                      "
                      x="0px"
                      y="0px"
                      viewBox="0 0 315.58 315.58"
                    >
                      <g>
                        <path
                          d="M310.58,33.331H5c-2.761,0-5,2.238-5,5v238.918c0,2.762,2.239,5,5,5h305.58c2.763,0,5-2.238,5-5V38.331 C315.58,35.569,313.343,33.331,310.58,33.331z M285.58,242.386l-68.766-71.214c-0.76-0.785-2.003-0.836-2.823-0.114l-47.695,41.979 l-60.962-75.061c-0.396-0.49-0.975-0.77-1.63-0.756c-0.631,0.013-1.22,0.316-1.597,0.822L30,234.797V63.331h255.58V242.386z"
                        />
                        <path
                          d="M210.059,135.555c13.538,0,24.529-10.982,24.529-24.531c0-13.545-10.991-24.533-24.529-24.533 c-13.549,0-24.528,10.988-24.528,24.533C185.531,124.572,196.511,135.555,210.059,135.555z"
                        />
                      </g>
                    </svg>
                    Selecione a Imagem
                    <input
                      type="file"
                      name="img"
                      style="display: none"
                      accept="image/jpg, image/jpeg, image/png, image/webp"
                      @change="handleUpload()"
                    />
                  </label>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col col-1-3" v-for="(img, index) in item.bg">
                  <div
                    class="thumbnail thumbnail-fixed"
                    v-bind:class="{ BorderActive: img === item.currentBg }"
                  >
                    <div class="LogoimgBox">
                      <img :src="getImage(img)" />
                    </div>
                    <div class="caption">
                      <div class="caption__actions">
                        <span
                          class="button button-sm success button-disabled"
                          v-if="img === item.currentBg"
                          >Ativo</span
                        >
                        <span
                          class="button button-sm"
                          v-else
                          v-on:click="setCurrent(img)"
                          >Clique para Ativar</span
                        >
                        <br />
                        <br />
                        <button
                          class="button button-sm button-error"
                          v-show="img !== item.currentBg"
                          v-on:click="removeImage(index)"
                        >
                          Remover
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, put, del, uploadImage } from "@/helpers/apiRequest";
import { getImage } from "@/helpers/utils";

const url = "/propaganda";

export default {
  name: "rodape",
  data() {
    return {
      loading: false,
      item: {
        _id: "",
        currentBg: -1,
        bg: [],
      },
    };
  },
  methods: {
    getImage: getImage,
    onSubmit() {},
    handleUpload() {
      event.preventDefault();
      const settings = {
        el: event.target,
        str: `/propaganda/bg/${this.item._id}`,
        dim: "1290x960",
      };
      this.loading = true;
      uploadImage(settings)
        .then((json) => {
          this.item.bg.push(json.filename);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setCurrent(name) {
      this.loading = true;
      const key = "currentBg";
      put(`/currentimg/propaganda/${key}/${this.item._id}/${name}`)
        .then((json) => {
          this.item[key] = name;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeImage(index) {
      if (this.item.bg.length === 1) {
        this.$swal({ title: "Não remova a única imagem", type: "error" });
        return;
      }
      this.$swal({
        title: "Deseja deletar esse catálogo ?",
        showCancelButton: true,
        type: "error",
      }).then(
        () => {
          this.loading = true;
          del(`/upload/propaganda/bg/${this.item._id}/${index}`)
            .then((json) => {
              this.item.bg = this.item.bg.filter((_, k) => +k !== index);
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
            });
        },
        () => {}
      );
    },
  },
  beforeMount() {
    this.loading = true;
    get(url)
      .then((json) => {
        this.loading = false;
        this.item = json;
      })
      .catch((err) => console.log("err", err));
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Propaganda/Bg.vue